// TeacherInformationSection.js
import { useState, useEffect } from "react"
import { Chip, Grid, InputAdornment } from "@mui/material"
import MDBox from "components/MDBox"
import MDTypography from "components/MDTypography"
import DataTable from "components/DataTable"
import { useLazyGetTeacherChangeLXOQuery } from "shared/redux/endpoints/lxo"
import { selectAuth } from "shared/redux/slices/authSlice"

import moment from "moment"

import { useAsyncDebounce } from "react-table"

import Icon from "@mui/material/Icon"
import { Loading } from "shared/components/ui/Loading"
import MDInput from "components/MDInput"
import SearchIcon from "@mui/icons-material/Search"
import ReactPaginate from "react-paginate"
import { chipStyle } from "components/CenterDashboardSection/style"
import { alertChipStyle } from "./style"
import MDSelect from "components/MDSelect"
import { useSelector } from "react-redux"

const TABLE_HEADERS = [
  { Header: "no", accessor: "id" },
  { Header: "Class name", accessor: "className" },
  { Header: "	No. of Teachers (This Month)", accessor: "thisMonth" },
  { Header: "	No. of Teachers (Last 3 Months)", accessor: "last3Months" },
  { Header: "Alert Status", accessor: "alertStatus" },
]

const teacherStatusOptions = [
  { value: "All", label: "All" },
  { value: "Critical", label: "Critical" },
  { value: "In alert", label: "In alert" },
  { value: "Normal", label: "Normal" },
]

export default function TeacherManagementChangeSection() {
  // State management matching CenterDashboardSection

  const auth = useSelector(selectAuth)

  const centerId = auth?.centerId
  const [state, setState] = useState({
    page: 0,
    size: 10,
    sort: "id,desc",
    start: moment().format("DD-MM-YYYY"),
    end: moment().format("DD-MM-YYYY"),
    keyword: "",
    teacherStatus: "All",
    centerId,
  })
  const [isLoading, setIsLoading] = useState(true)
  const [dataTable, setDataTable] = useState({
    columns: TABLE_HEADERS,
    rows: [],
  })
  const [pagination, setPagination] = useState({
    totalPage: 0,
    currentPage: 0,
  })

  const [trigger] = useLazyGetTeacherChangeLXOQuery()

  const handlerDataTable = (data) => {
    setDataTable({
      columns: TABLE_HEADERS,
      rows: data.map((item) => ({
        ...item,
        id: <MDTypography>{item.id}</MDTypography>,
        className: <MDTypography>{item.className}</MDTypography>,
        thisMonth: <MDTypography>{item.teacherOfMonth}</MDTypography>,
        last3Months: <MDTypography>{item.teacherOf3Month}</MDTypography>,
        alertStatus: (
          <Chip
            variant="outlined"
            label={item.status}
            sx={(theme) => ({
              ...chipStyle(theme),
              ...alertChipStyle(item.status, theme),
            })}
          />
        ),
      })),
    })
  }

  const handlderAPIList = (params) => {
    trigger(params).then((res) => {
      handlerDataTable(res?.data?.data?.data)
      setPagination({
        ...pagination,
        totalPage: res?.data?.data?.totalPage,
        currentPage: res?.data?.data?.currentPage,
      })
      setIsLoading(false)
    })
  }

  const handleInputChange = (e) => {
    const { name, value } = e.target
    setState((prev) => ({
      ...prev,
      [name]: value,
    }))
  }
  const handleChangePage = (page) => {
    handlderAPIList({
      ...state,
      page: page,
    })
  }

  // Fetch data when filters change
  useEffect(() => {
    handlderAPIList({ ...state, centerId })
  }, [centerId])

  console.log(centerId, "centerId")

  const handleSearchChange = useAsyncDebounce((e) => {
    const newState = {
      ...state,
      className: e.target.value,
      page: 0,
    }
    setState(newState)
    handlderAPIList(newState)
  }, 300)

  const teacherChangeStatusSelectProps = {
    placeholder: "Select Status",
    isSearchable: false,
    options: teacherStatusOptions,
    value: teacherStatusOptions.find(
      (option) => option.value === state.teacherStatus
    ),
    defaultValue: teacherStatusOptions.find(
      (option) => option.value === state.teacherStatus
    ),
    className: "form-input box-centers min-w-[150px] h-[2.8rem]",
    name: "teacherStatus",
    onChange: (e) => {
      setState((prev) => ({
        ...prev,
        status: e.value,
      }))
      handlderAPIList({
        ...state,
        status: e.value,
      })
    },
  }

  return (
    <Grid
      item
      xs={12}
      lg={8}
      xxl={7.5}
      className={`teacher-management__section teacher-management__change-section`}
    >
      {isLoading ? (
        <Loading style={{ height: 200, margin: "10% auto" }} />
      ) : (
        <MDBox className="teacher-management__table">
          <MDBox className="teacher-management__table-header">
            <MDTypography variant="h3" className="info-icon__title">
              Teacher Change
            </MDTypography>
          </MDBox>

          <MDBox className="teacher-management__table-filters">
            <MDInput
              className="input input-search"
              placeholder="Search by class name"
              name="className"
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon className="icon-search" />
                  </InputAdornment>
                ),
              }}
              onChange={handleSearchChange}
            />
            <MDSelect {...teacherChangeStatusSelectProps} />
          </MDBox>
          <MDBox className="teacher-management__table-wrapper">
            <DataTable
              table={dataTable}
              entriesPerPage={{
                isShown: true,
                defaultValue: state.size,
                entries: [5, 10, 25],
                pagination: true,
              }}
            />
            <MDBox className="table-footer">
              <MDBox className="table-footer-showing">
                Showing {dataTable?.rows?.length} of {dataTable?.rows?.length}{" "}
                entries
              </MDBox>
              {pagination.totalPage >= 0 && (
                <ReactPaginate
                  className="pagination"
                  nextLabel={<Icon>chevron_right</Icon>}
                  previousLabel={<Icon>chevron_left</Icon>}
                  forcePage={Number(state.page)}
                  onPageChange={(event) => {
                    handleChangePage(event.selected)
                  }}
                  pageCount={pagination.totalPage}
                />
              )}
            </MDBox>
          </MDBox>
        </MDBox>
      )}
    </Grid>
  )
}
